import { UserAuthFormData } from '@/components/auth-page/user-auth-form'
import { Icons } from '@/components/icons'
import { Button } from '@/components/ui/button'
import { useGoogleLoginMutation } from '@/src/mutations/auth/google-login'
import { useGoogleLogin } from '@react-oauth/google'
import { UseFormSetError } from 'react-hook-form'
import { toast } from 'sonner'
import { usePostHogEvents, EVENTS } from '@/lib/posthog-events'

export default function GoogleLogin({
  setError,
}: {
  setError: UseFormSetError<UserAuthFormData>
}) {
  const googleMutation = useGoogleLoginMutation()
  const { trackEvent } = usePostHogEvents()
  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      googleMutation.mutate(
        { authToken: tokenResponse.access_token },
        {
          onSuccess() {
            toast.success('Logged in with Google!')
            trackEvent(EVENTS.USER_LOGGED_IN, { provider: 'google', method: 'oauth', flow: 'popup' })
            // router.push('/home')
          },
          onError(error) {
            setError('root', {
              type: 'manual',
              message: error.message,
            })
            toast.error(error.message)
          },
        }
      )
    },
    onError: () => {
      toast.error('Error while logging in with Google')
      setError('root', {
        type: 'manual',
        message: 'Error while logging in with Google',
      })
    },
    onNonOAuthError: (error) => {
      if (error.type !== 'popup_closed') {
        toast.error('Error while logging in with Google')
        setError('root', {
          type: 'manual',
          message: 'Error while logging in with Google',
        })
      }
    },
  })

  return (
    <>
      <Button
        className="font-base flex-1 border border-gray bg-white text-black hover:bg-lightergray "
        onClick={(e) => {
          e.preventDefault()
          googleLogin()
        }}
        isLoading={googleMutation.isPending}
      >
        <Icons.google className="mr-2 h-4 w-4" />
        Continue with Google
      </Button>
    </>
  )
}